import { config } from '@mytaxi/config-store';

declare global {
    interface Window {
        OptanonWrapper: () => void;
        OnetrustActiveGroups?: string;
        dataLayer: any[];
    }
}

export const initializeOneTrust = (dataDomainScriptId: string) => {
    if (typeof window === 'undefined' || !config.getItem('gtmDataDomain')) return;
    if (document.getElementById('onetrust-script')) return;

    window.OptanonWrapper = function () {
        const activeGroups = window.OnetrustActiveGroups || '';

        const isC1 = true;
        const isC2 =
            activeGroups.includes('C0002') || activeGroups.includes('V2STACK42') || activeGroups.includes('V2STACK');
        const isC3 = activeGroups.includes('C0003');
        const isC4 = activeGroups.includes('C0004') || activeGroups.includes('V2STACK42');

        let classicGroupsString = ',C0001,';
        if (isC2) classicGroupsString += 'C0002,';
        if (isC3) classicGroupsString += 'C0003,';
        if (isC4) classicGroupsString += 'C0004,';

        window.OnetrustActiveGroups = classicGroupsString;

        window.dataLayer = window.dataLayer || [];

        const gtag = (...args: any[]) => {
            window.dataLayer.push(args);
        };

        gtag('consent', 'update', {
            ad_storage: isC4 ? 'granted' : 'denied',
            ad_user_data: isC4 ? 'granted' : 'denied',
            ad_personalization: isC4 ? 'granted' : 'denied',
            analytics_storage: isC2 ? 'granted' : 'denied',
            personalization_storage: isC4 ? 'granted' : 'denied',
            functionality_storage: isC3 ? 'granted' : 'denied',
            security_storage: isC1 ? 'granted' : 'denied',
        });

        window.dataLayer.push({
            event: 'OneTrustGroupsUpdated',
            OnetrustActiveGroups: classicGroupsString,
        });

        window.dispatchEvent(new Event('OneTrustGroupsUpdated'));
    };

    if (dataDomainScriptId) {
        const script = document.createElement('script');
        script.id = 'onetrust-script';
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.setAttribute('data-domain-script', dataDomainScriptId);

        document.head.appendChild(script);
    } else {
        console.warn('OneTrust domain ID is missing from config.');
    }
};
